import c from './styles.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { setMenuAction } from '../../store/menuReducer'

const MobileMenuBtn = () => {
    const dispatch = useDispatch()
    const {show} = useSelector(store => store.menu)

    const toggle = () => {
        dispatch(setMenuAction(!show))
    }

    return (
        <div
            className={[c.mobileBtn, show ? c.show : null].join(' ')}
            onClick={toggle}
        >
            <span></span>
            <span></span>
        </div>
    )
}

export default MobileMenuBtn